module.exports = __webpack_public_path__ + "static/media/LiveClassesEducation.fe8c66eb.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/liveClass/LiveClassesEducation.jpeg
// module id = 867
// module chunks = 7